module.exports = __webpack_public_path__ + "img/video-mobile.f8269ba.jpg";